import React from "react";
import Grid from "@mui/material/Grid";
import Pagination from "../../Shared/Layout/Pagination";
import {formatDateDMY} from "./../../Shared/helperFunctions"

const CustomTable = ({
  title,
  columns,
  data = [],
  pagination,
  emptyMessage = "No data found.",
}) => {
  return (
    <Grid>
      <div className="mb-10 w-full rounded-2xl bg-white p-4 shadow-custom md:p-6">
        {title && (
          <h2 className="mb-5 text-left text-xl font-semibold text-[#dc2626]">
            {title}
          </h2>
        )}

        <div className="overflow-x-auto">
          <table className="w-full min-w-[700px] border-separate border-spacing-0">
            <thead>
              <tr className="text-left">
                {columns.map((column, index) => (
                  <th
                    key={index}
                    className={`border-b border-slate-200 px-4 py-3 text-sm font-semibold text-slate-700 ${
                      column.headerClassName || ""
                    }`}
                  >
                    {column.header}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {data.length > 0 ? (
                <>
                  {data.map((row, rowIndex) => (
                    <tr
                      key={row.id || rowIndex}
                      className="text-left transition-colors duration-200 hover:bg-slate-50"
                    >
                      {columns.map((column, colIndex) => (
                        <td
                          key={colIndex}
                          className={`border-b border-slate-100 px-4 py-4 text-sm ${
                            column.cellClassName || "text-slate-700"
                          }`}
                        >
                          { column?.isObject ? row[column.accessor]?.name : (
                            column.render
                              ? column.render(row, rowIndex)
                              : column.isDate
                              ? formatDateDMY(row[column.accessor])
                              : row[column.accessor]
                          )}
                        </td>
                      ))}
                    </tr>
                  ))}

                  {pagination?.count > 0 && (
                    <tr>
                      <td colSpan={columns.length}>
                        <Pagination
                          count={pagination.count}
                          pageSize={pagination.pageSize}
                          page={pagination.page}
                          action={pagination.onPageChange}
                        />
                      </td>
                    </tr>
                  )}
                </>
              ) : (
                <tr>
                  <td
                    colSpan={columns.length}
                    className="px-4 py-6 text-center text-sm text-slate-500"
                  >
                    {emptyMessage}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </Grid>
  );
};

export default CustomTable;